import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import {
  CONTACT_POINT__FEATURE_KEY,
  ContactPointEffects,
  MfaPreferenceEffects,
  MfaPreferenceFacade,
  RESET_PASSWORD__FEATURE_KEY,
  ResetPasswordEffects,
  ResetPasswordFacade,
  contactPointReducer,
  resetPasswordReducer,
} from './+state';
import { InvitationsEffects } from './+state/invitations/invitations.effects';
import { InvitationsFacade } from './+state/invitations/invitations.facade';
import * as fromInvitations from './+state/invitations/invitations.reducer';
import * as fromMfaPreference from './+state/mfa-preference/mfa-preference.reducer';
import { PrizesEffects } from './+state/prizes/prizes.effects';
import { PrizesFacade } from './+state/prizes/prizes.facade';
import * as fromPrizes from './+state/prizes/prizes.reducer';
import { ProfileEffects } from './+state/profile/profile.effects';
import { ProfileFacade } from './+state/profile/profile.facade';
import * as fromProfile from './+state/profile/profile.reducer';
import { ReferralsEffects } from './+state/referrals/referrals.effects';
import { ReferralsFacade } from './+state/referrals/referrals.facade';
import * as fromReferrals from './+state/referrals/referrals.reducer';
import { SuggestionsEffects } from './+state/suggestions/suggestions.effects';
import { SuggestionsFacade } from './+state/suggestions/suggestions.facade';
import * as fromSuggestions from './+state/suggestions/suggestions.reducer';
import { VerifyUserIdentityEffects } from './+state/verify-user-identity/verify-user-identity.effects';
import { VerifyUserIdentityFacade } from './+state/verify-user-identity/verify-user-identity.facade';
import * as fromVerifyUserIdentity from './+state/verify-user-identity/verify-user-identity.reducer';
import { WinnerEffects } from './+state/winner/winner.effects';
import { WinnerFacade } from './+state/winner/winner.facade';
import * as fromWinner from './+state/winner/winner.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      fromProfile.PROFILE_FEATURE_KEY,
      fromProfile.reducer,
    ),
    StoreModule.forFeature(
      fromReferrals.REFERRALS_FEATURE_KEY,
      fromReferrals.reducer,
    ),
    StoreModule.forFeature(
      fromInvitations.INVITATIONS_FEATURE_KEY,
      fromInvitations.reducer,
    ),
    StoreModule.forFeature(
      fromSuggestions.SUGGESTIONS_FEATURE_KEY,
      fromSuggestions.reducer,
    ),
    StoreModule.forFeature(RESET_PASSWORD__FEATURE_KEY, resetPasswordReducer),
    StoreModule.forFeature(fromWinner.WINNER_FEATURE_KEY, fromWinner.reducer),
    StoreModule.forFeature(
      fromPrizes.PRIZES_FEATURE_KEY,
      fromPrizes.prizesReducer,
    ),
    StoreModule.forFeature(CONTACT_POINT__FEATURE_KEY, contactPointReducer),
    EffectsModule.forFeature([
      ReferralsEffects,
      InvitationsEffects,
      SuggestionsEffects,
      WinnerEffects,
      ProfileEffects,
      PrizesEffects,
      ResetPasswordEffects,
      ContactPointEffects,
    ]),
    StoreModule.forFeature(
      fromVerifyUserIdentity.VERIFY_USER_IDENTITY_FEATURE_KEY,
      fromVerifyUserIdentity.verifyUserIdentityReducer,
    ),
    EffectsModule.forFeature([VerifyUserIdentityEffects]),
    StoreModule.forFeature(
      fromMfaPreference.MFA_PREFERENCE_FEATURE_KEY,
      fromMfaPreference.enableMfaReducer,
    ),
    EffectsModule.forFeature([MfaPreferenceEffects]),
  ],
  providers: [
    ProfileFacade,
    ReferralsFacade,
    InvitationsFacade,
    SuggestionsFacade,
    ResetPasswordFacade,
    MfaPreferenceFacade,
    WinnerFacade,
    PrizesFacade,
    VerifyUserIdentityFacade,
  ],
})
export class ProfileDataAccessModule {}
